import MultistreamingScene from '../../scenes/MarketingPages/scenes/Multistreaming';

export default MultistreamingScene;
